import { Component, h } from "@lukekaalim/act"
import { html } from "@lukekaalim/act-web"

import classes from './Hero.module.css';
import { assetURLs } from "../../assets";
import { useModalManager } from "@kosmod/kit";
import { useFrontendCore, useFrontendServices } from "@kosmod/core";
import { createAuthenticateModal } from "../Authenticate";
import { AuthState } from "../../hooks";

export type HeroProps = {
  auth: AuthState,
}

export const Hero: Component<HeroProps> = ({ auth }) => {
  const { site, modal } = useFrontendServices();

  return h(html.div, { className: classes.hero }, [
    h(html.div, { className: classes.carousel }, [
      h(html.div, { className: classes.spiel }, [
        h(html.img, { className: classes.brandImage, src: assetURLs.kosmodTransparentLogoWhite }),
        h(html.p, { className: classes.text }, `Damn, isn't copy text cool? Doesn't it make you want to BUY PRODUCT`)
      ]),
      h(html.video, { src: assetURLs.videos["devclip-voice-chat-1"], className: classes.demo, controls: true, autoplay: true, volume: 0 }),
    ]),
    h(html.div, { className: classes.actions }, [
      h(html.button, { className: classes.callToAction, onClick() {
        site.navigate({ path: '/demo' })
      }, }, 'Open Editor'),
    ]),
    h(html.div, { className: classes.secondaryActions }, [
      h(html.button, { className: classes.secondaryCallToAction, onClick() { modal.add(createAuthenticateModal('login', auth)) } }, 'Login'),
      h(html.span, {}, ' or '),
      h(html.button, { className: classes.secondaryCallToAction }, 'Join\nwith Code'),
    ])
  ]);
}